import { render, staticRenderFns } from "./PageBreadcrumbs.vue?vue&type=template&id=72406977&scoped=true&"
import script from "./PageBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./PageBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./PageBreadcrumbs.vue?vue&type=style&index=0&id=72406977&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72406977",
  null
  
)

export default component.exports